<template>
  <div class="widget">
    <h3>新闻/文章
      <router-link to="/news" class="more">更多&gt;</router-link>
    </h3>
    <article v-for="item in tableData" :key="item.article_id" class="news-entry">
      <header class="entry-head">
        <h4>
          <router-link :to="`/newscontent/${item.article_id}`">{{ item.article_title }}</router-link>
        </h4>
        <div class="w-meta">
          <span class="icon">🕐</span>{{ item.article_createtime | dataFormat }}
          <span class="read"><span class="icon">👁</span>{{ item.article_read_num }}</span>
        </div>
      </header>
      <p class="entry-summary">
        {{ item.article_introduction }}
        <router-link :to="`/newscontent/${item.article_id}`">...查看更多</router-link>
      </p>
    </article>
  </div>
</template>

<script>
import { getArticleList } from '@/api'

export default {
  name: 'NewsWidget',
  data() {
    return { tableData: [] }
  },
  created() {
    getArticleList({ page: 1, pagesize: 3 }).then((res) => {
      this.tableData = res.data || []
    })
  }
}
</script>
